import styled from 'styled-components';
import { font, space, color, query } from '@design/templateFns';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: auto;

  @media screen and (${query.atLeast('desktop')}) {
    max-width: 700px;
  }
`;

export const AdvisorWrapper = styled.div<{ $gridSize?: number }>`
  display: grid;
  grid-template-columns: ${({ $gridSize }) => ($gridSize ? `repeat(${$gridSize}, 1fr)` : 'repeat(3, 1fr)')};
  gap: ${space('xl')};
  flex-direction: row;
  max-width: 700px;
  margin: auto;
  @media screen and (${query.atLeast('desktop')}) {
    gap: ${space('x7')};
  }
  @media screen and (${query.atLeast('tablet')}) {
    margin-top: ${space('x8')};
    gap: ${space('x10')};
    grid-template-columns: ${({ $gridSize }) => ($gridSize ? `repeat(${$gridSize}, 1fr)` : 'repeat(3, 1fr)')};
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  @media screen and (${query.atLeast('tablet')}) {
    margin-top: 0;
  }
`;

export const Eyebrow = styled.h3`
  text-transform: uppercase;
  color: ${color('cta')};
  ${font('eyebrow-md')};
  padding-bottom: 32px;
  margin-top: 40px;
  font-size: 12px;

  @media screen and (${query.atLeast('desktop')}) {
    font-size: 14px;
    line-height: 18px;
  }
`;

export const Header = styled.h2`
  ${font('headline-sm')};
  margin: 0 0 16px;
  padding: 0;
  text-align: center;
  font-size: 26px;
  @media screen and (${query.atLeast('tablet')}) {
    font-size: 40px;
  }
`;

export const Text = styled.div`
  color: ${color('gray5')};
  padding-bottom: 32px;
  ${font('body-md-light')};
  font-size: 14px;
  @media screen and (${query.atLeast('tablet')}) {
    font-size: 16px;
  }
`;

export const StyledSpan = styled.span`
  ${font('headline-xs')};
  color: ${color('cta')};
  margin-right: 9px;
  position: relative;
  bottom: 1px;
  cursor: pointer;
`;

export const ImageWrapper = styled.div`
  width: 103px;
  height: 103px;
  @media (max-width: 700px) {
    width: 63px;
    height: 63px;
  }
`;
